function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "asset_per_mappa");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "ASSET"
}, /*#__PURE__*/React.createElement("path", {
  d: "M41.1,21.51c-1.07-1.8-3-2-4.72-1.56a22.78,22.78,0,0,1,4.12-2.9l-7.18-3.44-7.18-3.44a23.65,23.65,0,0,1,.35,4.9c-.79-1.53-2.1-2.8-4.09-2.51a2.35,2.35,0,0,0-1.59,1c-1.24,1.64-1.11,5.19-.94,7.12a9.61,9.61,0,0,0-2.75,3.43C14.6,29.36,14.58,41.7,14.58,41.7l3.83,1.83.95.46,3.83,1.84s9.6-7.76,12.12-13a9.36,9.36,0,0,0,.95-4.17c1.59-1.05,4.55-3.22,5.07-5.26A2.39,2.39,0,0,0,41.1,21.51Zm-19.52-2c-.1-1.92,0-4.05.65-4.91a.63.63,0,0,1,.42-.28C24.22,14.1,25,16,25.4,17.2A24.48,24.48,0,0,1,21.58,19.51Zm18,3.41c-.27,1.06-1.92,2.52-3.5,3.65a26.11,26.11,0,0,1-.62-4.44c1.14-.49,3.23-1.13,4.08.3A.6.6,0,0,1,39.61,22.92Z"
}));

var SvgIcoAmphora = function SvgIcoAmphora(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 56 56",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcoAmphora, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ico_amphora.c2930f01.svg";
export { ForwardRef as ReactComponent };